
const commonRouter = [
  {
    path: '/',
    redirect: '/about'
  },
  {
    path: '/about',
    name: 'about',
    component: resolve => (require(["@/pages/about"], resolve)),
    meta: {
      title: '兴旺投资'
    }
  },
  {
    path: '/aboutDetail',
    name: 'aboutDetail',
    component: resolve => (require(["@/pages/aboutDetail"], resolve)),
    meta: {
      title: '关于我们'
    }
  },
  {
    path: '/portfolio',
    name: 'portfolio',
    component: resolve => (require(["@/pages/portfolio"], resolve)),
    meta: {
      title: '投资组合'
    }
  },
  {
    path: '/team',
    name: 'team',
    component: resolve => (require(["@/pages/team"], resolve)),
    meta: {
      title: '管理团队'
    }
  },
  {
    path: '/teamDetail',
    name: 'teamDetail',
    component: resolve => (require(["@/pages/teamDetail"], resolve)),
    meta: {
      title: '团队详情'
    }
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: resolve => (require(["@/pages/newsCenter"], resolve)),
    meta: {
      title: '新闻中心'
    }
  },
  {
    path: '/newsDetail',
    name: 'newsDetail',
    component: resolve => (require(["@/pages/newsDetail"], resolve)),
    meta: {
      title: '新闻详情'
    }
  },
  {
    path: '/contact',
    name: 'contact',
    component: resolve => (require(["@/pages/contact"], resolve)),
    meta: {
      title: '联系我们'
    }
  }
]
export { commonRouter }



// WEBPACK FOOTER //
// ./src/router/router.js